"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesAutocompleteComboboxInput = exports.AroundMeButton = exports.AgenciesMapSearchGeo = exports.AgenciesMapSearchBox = exports.AgenciesMapSearchWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
const fdr_regular_fusion_fdr_autocomplete_combobox_1 = require("@hotelplan/fdr.regular.fusion.fdr-autocomplete-combobox");
exports.AgenciesMapSearchWrapper = styled_components_1.default.div(({ theme }) => theme.agency.mapSearch.wrapper);
exports.AgenciesMapSearchBox = styled_components_1.default.div(({ theme }) => theme.agency.mapSearch.box);
exports.AgenciesMapSearchGeo = styled_components_1.default.div(({ theme }) => theme.agency.mapSearch.geo);
exports.AroundMeButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon)(({ theme: { space } }) => ({
    color: 'black',
    marginRight: space[3],
    paddingTop: space[2],
    paddingBottom: space[2],
}));
exports.AgenciesAutocompleteComboboxInput = (0, styled_components_1.default)(fdr_regular_fusion_fdr_autocomplete_combobox_1.FdrAutocompleteComboboxInput)(({ theme: { media } }) => ({
    input: {
        height: '45px',
        [media.tablet]: {
            height: '60px',
        },
    },
    marginBottom: 0,
}));
//# sourceMappingURL=fdr-agency-map-search.styles.js.map